<template>
	<div class="col" gutter="20">
		<Title title="管理會員" />
		<SearchBar :searchText="searchText" @search="handleSearch" placeholder="姓名、Email、單位、地區、職位" />
		<el-pagination align-self="right" @size-change="sizeChange" @current-change="currentChange" :current-page="page" :page-sizes="[10, 30, 50, 100]" :page-size="size" layout="total, sizes, prev, pager, next, jumper" :total="_total" />
		<upload accept=".csv" />
		<el-table :data="_list" style="width: 100%" :default-sort="{prop: 'create_time', order: 'descending'}">
			<el-table-column prop="name" label="姓名" />
			<el-table-column prop="cellphone" label="電話" />
			<el-table-column prop="department" label="單位" />
			<el-table-column prop="position" label="職位" />
			<el-table-column prop="email" label="Email" />
			<el-table-column prop="create_time" label="加入時間" sortable />
			<el-table-column prop="session_list" label="歷屆報名挑戰" align="center">
				<template slot-scope="{row}">
					<pre v-if="row.session_list">{{row.session_list && row.session_list.join("\n")}}</pre>
				</template>
			</el-table-column>
			<el-table-column width="50">
				<template slot-scope="{row}">
					<el-button icon="el-icon-delete" @click="handleDelete(row.email)" size="mini" type="danger" plain circle />
				</template>
			</el-table-column>
		</el-table>
		<el-pagination align-self="right" @size-change="sizeChange" @current-change="currentChange" :current-page="page" :page-sizes="[10, 30, 50, 100]" :page-size="size" layout="total, sizes, prev, pager, next, jumper" :total="_total" />
	</div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Title from "@/components/backendManage/Title";
import SearchBar from "@/components/backendManage/SearchBar";
import Upload from "../../../components/ManageMember/upload.vue";

export default {
	components: { Title, SearchBar, Upload },
	data() {
		return {
			page: 1,
			size: 10,
			searchText: "",
			status: "全部",
		};
	},
	computed: {
		...mapState("merrymama-user", [
			"_list",
			"_total",
		]),
		query() {
			return {
				page: this.page,
				size: this.size,
				text: this.searchText,
				status: this.status
			};
		}
	},
	methods: {
		...mapActions('manager', ['getUserList', 'getAllUsers']),
		...mapActions("merrymama-user", [
			"_getMerryMamaUserList",
			"_deleteMerryMamaUser",
		]),
		init() {
			this.page = Number(this.$route.query.page) || 1;
			this.size = Number(this.$route.query.size) || 10;
			this.searchText = this.$route.query.text || '';
			this.status = this.$route.query.status || '全部';
		},
		handleSearch(text) {
			this.searchText = text;
			this.page = 1;
			this.$router.push({ query: this.query });
		},
		sizeChange(size) {
			this.size = size;
			this.page = 1;
			this.$router.push({ query: this.query });
		},
		currentChange(page) {
			this.page = page;
			this.$router.push({ query: this.query });
		},
		statusChange(status) {
			this.status = status;
			this.page = 1;
			this.$router.push({ query: this.query });
		},
		handleDelete(email) {
			this.$confirm(`確定要刪除「${email}」？`, "刪除", {
				confirmButtonText: "確定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(async () => {
				try {
					await this._deleteMerryMamaUser(email);
					this.$message.success("success");
				} catch (error) {
					this.$message.error(error.message);
				}
			}).catch(() => { });
		}
	},
	async created() {
		this.init();
		this._getMerryMamaUserList(this.query);
	},
	beforeRouteUpdate(to, from, next) {
		if (to.fullPath != from.fullPath) {
			this._getMerryMamaUserList(this.query)
				.then(next);
		}
	}
};
</script>

<style lang="scss" scoped>
</style>